import { useEffect, useRef, useState } from "react";
import * as pdfjs from "pdfjs-dist/legacy/build/pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

export function PdfView({ url }) {
  const box = useRef();
  const [err, setErr] = useState(false);
  useEffect(() => {
    let off = false;
    const el = box.current;
    el.innerHTML = "";
    setErr(false);
    (async () => {
      try {
        const pdf = await pdfjs.getDocument(url).promise;
        const w = el.clientWidth || 360;
        for (let i = 1; i <= pdf.numPages && !off; i++) {
          const page = await pdf.getPage(i);
          const base = page.getViewport({ scale: 1 });
          const vp = page.getViewport({ scale: (w / base.width) * Math.min(window.devicePixelRatio || 1, 2) });
          const cv = document.createElement("canvas");
          cv.width = vp.width; cv.height = vp.height;
          cv.style.width = "100%"; cv.style.marginBottom = "8px"; cv.style.background = "#fff";
          cv.setAttribute("data-testid", `pdf-page-${i}`);
          el.appendChild(cv);
          await page.render({ canvasContext: cv.getContext("2d"), viewport: vp }).promise;
        }
      } catch { if (!off) setErr(true); }
    })();
    return () => { off = true; };
  }, [url]);
  return (
    <div className="w-full h-full overflow-auto" data-testid="pdf-view">
      {err && <div className="text-sm text-red-400 p-4" data-testid="pdf-view-error">Impossibile mostrare il PDF. Usa il pulsante Scarica.</div>}
      <div ref={box} className="w-full" />
    </div>
  );
}
